
































































































































import { TarifEventSchedulerActiviteDocument } from "@/models/TarifEventSchedulerActiviteDocument";
import { utils } from "@/util";
import moment from "moment";
import Vue from "vue";
import { mapGetters } from "vuex";
export default Vue.extend({
  props: {
    tempsAccueil: {
      type: Array,
      default: () => [],
    },
    nbrIndividus: {
      type: Number,
      default: 0,
    },
    listsupplements: {
      type: Array,
      default: () => [],
    },
    tempsAccueilActif: {
      type: Array,
      default: () => [],
    },
    nbrIndividusPresents: {
      type: Number,
      default: () => 0,
    },
    nbrIndividusFiltreesPresents: {
      type: Number,
      default: 0,
    },
    nbrIndividusTotal: {
      type: Number,
      default: 999,
    },
  },
  computed: {
    tempsAC() {
      return this.tempsAccueil.filter(
        (temps: any) =>
          temps.resource_id === "AC" &&
          this.tempsAccueilActif.includes(temps.id)
      );
    },
    tempsTS() {
      return this.tempsAccueil.filter(
        (temps: any) =>
          temps.resource_id === "TS" &&
          this.tempsAccueilActif.includes(temps.id)
      );
    },
    ...mapGetters("activites", ["getDate", "getIsDateDiff"]),
  },
  methods: {
    pointageGlobalArrivee(temps: TarifEventSchedulerActiviteDocument) {
      let splitedDate = (this.getDate as string).split("-");
      let now = utils.getCurrentTimeNow(
        splitedDate[0],
        splitedDate[1],
        splitedDate[2]
      );
      if (temps.getHeure_debut_fixe())
        this.$emit("pointage-global", [
          temps,
          now.format("YYYY-MM-DD") + " " + temps.getHeure_debut_fixe() + ":00",
          "arrivée",
        ]);
      else
        this.$emit("pointage-global", [
          temps,
          temps.getStart_date(),
          "arrivée",
        ]);
    },
    pointageGlobalDepart(temps: TarifEventSchedulerActiviteDocument) {
      let splitedDate = (this.getDate as string).split("-");
      let now = utils.getCurrentTimeNow(
        splitedDate[0],
        splitedDate[1],
        splitedDate[2]
      );
      if (temps.getHeure_fin_fixe())
        this.$emit("pointage-global", [
          temps,
          now.format("YYYY-MM-DD") + " " + temps.getHeure_fin_fixe() + ":00",
          "départ",
        ]);
      else
        this.$emit("pointage-global", [temps, temps.getEnd_date(), "départ"]);
    },
    showListeUrgence(filtred: boolean) {
      this.$emit("show-liste-urgence", filtred);
    },
  },
  filters: {
    formatDate(value: string) {
      return moment(value).format("HH:mm");
    },
  },
});
